export interface BookingAgentInformation {
    agencyID: number;
    accam: string;
    agencyLongName: string;
    agentCode: string;
}
